// extracted by mini-css-extract-plugin
export default {"cards":"SummaryCards_cards__hzrqh","card":"SummaryCards_card__5RuFa","label":"SummaryCards_label__mp3T5","value":"SummaryCards_value__7O0H8"};